import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_HIERARCHICAL_TEAMS = registerQuery({
  fieldName: 'assignableTeams',
  args: ['includeHierarchy'],
  fetcher({
    includeHierarchy = true
  }) {
    return http.get(`app-users/v1/teams?includeHierarchy=${includeHierarchy}`);
  }
});
export const GET_HIERARCHICAL_TEAMS_BY_USER = registerQuery({
  fieldName: 'assignableTeamsByUser',
  fetcher() {
    return http.get('app-users/v1/teams/user/all/unique');
  }
});